import { Divider, Paper, Typography } from '@mui/material'
import TableLearningGrowth from '../../../../../card/TableLearningGrowth/TableLearningGrowth.jsx'
import Dialog from '../../../../../dialog/Dialog'
import TextStatusUnitOfLearning from '../../../../../text/TextStatus'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { currentMarking, initialMarking } from '../../../../../card/LearningGrowth/Styles.js'

const DialogLcs = ({ show, onClose, data, currentCurriculum, size }) => {
  const backgroundColor = data?.maxLevel?.primaryColor || 'transparent'
  const color = data?.maxLevel?.secondaryColor || 'inherit'
  const width = size * 0.6
  return (
    <Dialog
      id='dialog-lcs'
      show={show}
      onClose={onClose}
      title='Learning Competencies'
      maxWidth='md'
      fullWidth={true}
      onCloseHeader={onClose}
    >
      <div className='max-h-screen-modal-content overflow-auto min-h-screen-1/2'>
        <div className='sticky top-0px left-0px bg-background w-full z-12 h-14 flex items-center justify-between gap-4 grid grid-cols-6 '>
          <div className='col-span-4'>
            <Typography className='text-sm'>{data?.classCode || 'Student Name'}</Typography>
            <div>
              <TextStatusUnitOfLearning startDate={data?.drStartDate} endDate={data?.drEndDate} />
              <span className='font-bold  pl-1 text-2xl'>{data?.drName || ''}</span>
            </div>
          </div>
          {data?.maxLevel && (
            <div className='flex items-center gap-2'>
              <Paper
                className='size-10 text-center h-10 flex items-center justify-center rounded capitalize font-bold text-xs'
                style={{
                  width: size,
                  height: size,
                  backgroundColor,
                  color
                }}
              />
              <div className='flex flex-col items-start'>
                <Typography className='font-bold text-center'>{data?.maxLevel?.levelName}</Typography>
                <Typography className='font-bold  text-sm text-center'>
                  {data?.maxLevel?.completedName}
                </Typography>
              </div>
            </div>
          )}
          <div className='flex flex-col gap-2 '>
            <div className='flex items-center gap-2 h-5'>
              <div
                style={{ width, height: width }}
                className=' flex items-center justify-center rounded-full'
              >
                <FontAwesomeIcon icon={initialMarking} size='lg' />
              </div>
              <Typography className=' text-xs text-nowrap'>Starting Level</Typography>
            </div>
            <div className='flex items-center gap-2 h-5'>
              <div
                style={{ width, height: width }}
                className=' flex items-center justify-center rounded-full'
              >
                <FontAwesomeIcon icon={currentMarking} size='lg' />
              </div>
              <Typography className=' text-xs text-nowrap'>Current Level</Typography>
            </div>
          </div>
        </div>
        <Divider className='my-2' />
        <TableLearningGrowth
          lcs={data?.lcs || []}
          maxLevel={data?.maxLevel || {}}
          loading={false}
          currentCurriculum={currentCurriculum}
          size={size}
        />
      </div>
    </Dialog>
  )
}

export default DialogLcs
